import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete-icon-new.svg";
import { ReactComponent as DragIcon } from "../../../assets/icons/drag-icon.svg";
import { ATTR_OPTION_ACTIONS } from "../../../constants/variantConstants";
import UBInput from "../../../Libraries/UBInput";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const VariantInput = ({
  value,
  handleChange,
  placeholder,
  showDelete = true,
  viRef,
  inputClassName,
  showError = false,
  disabled = false,
  ...props
}) => {
  return (
    <div
      ref={viRef}
      className='d-flex align-items-center justify-content-between gap-1 my-3 user-select-none flex-grow-1'
      {...props}
    >
      <DragIcon role='button' />
      <UBInput
        inputId="variant_attr_input"
        placeholder={placeholder}
        baseClassname={`flex1 colorInputspace ${inputClassName} ${styles.VariantInputField} ${showError ? "errBorder" : disabled ? "variant_disabled_class" : ""
          }`}
        value={value}
        onChange={(key, value) => {
          handleChange(ATTR_OPTION_ACTIONS.INPUT, value);
        }}
        maxLength={24}
        disabled={disabled}
      />
      {showDelete ? (
        <DeleteIcon
          role='button'
          onClick={() => { triggerLogEvent(analytics, "sb_variant_attr_option_delete"); handleChange(ATTR_OPTION_ACTIONS.DELETE, ""); }}
        />
      ) : null}
    </div>
  );
};

export default VariantInput;
